import { AssetScope } from "@supernova-studio/model";
import { z } from "zod";
export const DTOAssetScope = AssetScope;
export const DTOFileUploadItem = z.object({
    size: z.number(),
    name: z.string(),
    checksum: z.string(),
    scope: DTOAssetScope.exclude([
        "ComponentThumbnail",
        "DocumentationFrame",
    ]).optional(),
});
export const DTOFileUploadPayload = z.object({
    files: z.array(DTOFileUploadItem),
});
export const DTOFileUploadResponseItem = z.object({
    fileId: z.string(),
    referencePersistentId: z.string(),
    name: z.string(),
    checksum: z.string(),
    pendingUpload: z.boolean().optional(),
    url: z.string(),
    size: z.number(),
});
export const DTOFileResponseItem = DTOFileUploadResponseItem;
export const DTOUploadUrlItem = z.object({
    fileId: z.string(),
    uploadUrl: z.string(),
});
export const DTOFileUploadResponse = z.object({
    files: z.array(DTOFileUploadResponseItem),
    uploadUrls: z.array(DTOUploadUrlItem),
});
/**
 * @deprecated Use GET method with DTOFilesGetQuery
 */
export const DTOFilesGetPayload = z.object({
    persistentIds: z.string().array().optional(),
});
export const DTOFilesGetQuery = z.object({
    includeScope: DTOAssetScope.optional(),
});
export const DTOFilesResponse = z.object({
    files: z.array(DTOFileResponseItem),
});
export const DTOFileUploadFinalizePayload = z.object({
    fileIds: z.array(z.string()),
});
export const DTOFileUploadFinalizeResponse = z.object({ ok: z.literal(true) });
